export enum IdentificadorEnum {
  CPF = 1,
  CNPJ = 2,
  PlacaCavalo = 3,
  PlacaCarreta = 4
}
